import type { Provider } from '@angular/core';
import { InjectionToken } from '@angular/core';

export interface ColorsConfig {
  brandColor: string;
  brandColorDark: string;
}

export const BRAND_COLORS = new InjectionToken<ColorsConfig>('BRAND_COLORS');

/**
 * Provides brand colors configuration for standalone components
 * @param config The colors configuration
 * @returns An array of providers
 */
export function provideBrandColors(config: ColorsConfig): Provider[] {
  return [
    {
      provide: BRAND_COLORS,
      useValue: config,
    },
  ];
}
